<script lang="ts">
  import { Route } from "svelte-navigator";

  import routes from "../SLAKRoutes";
  import Home from "../pages/Home.svelte";
  import DefaultPage from "../pages/DefaultPage.svelte";
</script>

<div id="mainRouter">
  <Route path="/">
    <Home />
  </Route>
  {#each routes as route}
    {#if route.kind === "internal +navbar"}
      <Route path={route.path}>
        <DefaultPage {route} />
      </Route>
    {:else if route.kind === "internal custom" || route.kind === "internal custom +navbar"}
      <Route path={route.path}>
        <svelte:component this={route.component} />
      </Route>
    {/if}
  {/each}
</div>

<style>
</style>
